module.exports = __webpack_public_path__ + "./Jenny_second2_675bc231c365fa7332708005d742d68f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Jenny_second2.png
// module id = 563
// module chunks = 0